<template>
  <modal-vue
    @close="handleToggleModal"
    :modalActive="modals[modalName]"
    :hasFooterBorder="true"
    isFilterModal
  >
    <template #header>
      <v-row dense>
        <v-col cols="12" class="text-left text-xl">
          <strong>Exportar dashboard</strong>
        </v-col>
      </v-row>
    </template>
    <v-row dense>
      <v-col cols="12" md="6">
        <DatePicker
          v-model="startDate"
          class="w-full"
          locale="pt-BR"
          :masks="{ input: `DD/MM/YYYY` }"
        >
          <template #default="{ inputValue, inputEvents }">
            <v-text-field
              placeholder="Dia Inicial"
              :prepend-inner-icon="mdiCalendar"
              :value="inputValue"
              v-on="inputEvents"
              density="compact"
              variant="outlined"
              class="w-full"
              color="primary20"
              :error="!!startDateError"
              :error-messages="startDateError"
            />
          </template>
        </DatePicker>
      </v-col>
      <v-col cols="12" md="6">
        <DatePicker v-model="endDate" locale="pt-BR" :masks="{ input: `DD/MM/YYYY` }">
          <template #default="{ inputValue, inputEvents }">
            <v-text-field
              placeholder="Dia Final"
              :prepend-inner-icon="mdiCalendar"
              :value="inputValue"
              v-on="inputEvents"
              density="compact"
              variant="outlined"
              class="w-full"
              color="primary20"
              :error="!!endDateError"
              :error-messages="endDateError"
            />
          </template>
        </DatePicker>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col class="font-bold text-left text-md" cols="12">Incluir no PDF:</v-col>

      <v-row dense>
        <v-col cols="12" md="6" class="flex items-center">
          <v-checkbox
            v-model="stationFixo"
            density="compact"
            label="Plantão Fixo"
            color="primary"
            hide-details
          />
          <div class="w-[15px] h-[15px] bg-primary10 rounded"></div>
        </v-col>
        <v-col cols="12" md="6" class="flex items-center">
          <v-checkbox
            v-model="stationCobertura"
            density="compact"
            label="Plantão Cobertura"
            color="primary"
            hide-details
          />
          <div class="w-[15px] h-[15px] bg-tertiary rounded"></div>
        </v-col>
        <v-col cols="12" md="6" class="flex items-center">
          <v-checkbox
            v-model="stationExtra"
            density="compact"
            label="Plantão Extra"
            color="primary"
            hide-details
          />
          <div class="w-[15px] h-[15px] bg-feedBackSuccess rounded"></div>
        </v-col>
        <v-col cols="12" md="6" class="flex items-center">
          <v-checkbox
            v-model="openedStation"
            density="compact"
            label="Vaga Aberta"
            color="primary"
            hide-details
          />
          <div class="w-[15px] h-[15px] bg-alert rounded"></div>
        </v-col>
        <v-col cols="12" md="6" class="flex items-center">
          <v-checkbox
            v-model="confirmed"
            density="compact"
            label="Confirmado"
            color="primary"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6" class="flex items-center">
          <v-checkbox
            v-model="notConfirmed"
            density="compact"
            label="Não confirmado"
            color="primary"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6" class="flex items-center">
          <v-checkbox
            v-model="doctorPending"
            density="compact"
            label="Médico Pendente"
            color="primary"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6" class="flex items-center">
          <v-checkbox
            v-model="hideLabels"
            density="compact"
            label="Ocultar legendas"
            color="primary"
            hide-details
          />
        </v-col>
      </v-row>
    </v-row>
    <v-row dense class="md:py-5">
      <card
        v-if="openedStation"
        type="ABERTO"
        :confirmed="confirmed"
        :not-confirmed="notConfirmed"
        :doctor-pending="doctorPending"
        :hide-labels="hideLabels"
      />
      <card
        :confirmed="confirmed"
        :not-confirmed="notConfirmed"
        :doctor-pending="doctorPending"
        v-if="stationFixo"
        type="FIXO"
        :hide-labels="hideLabels"
      />
      <card
        :confirmed="confirmed"
        :not-confirmed="notConfirmed"
        :doctor-pending="doctorPending"
        v-if="stationCobertura"
        type="COBERTURA"
        :hide-labels="hideLabels"
      />
      <card
        :confirmed="confirmed"
        :not-confirmed="notConfirmed"
        :doctor-pending="doctorPending"
        v-if="stationExtra"
        type="EXTRA"
        :hide-labels="hideLabels"
      />
    </v-row>
    <v-row class="text-left">
      <v-col class="text-sm text-primary" v-if="unitsFilter?.length" cols="12">
        Unidades:
        <span class="font-bold"> {{ unitsFilter?.map((s) => s.text).join(', ') }}</span>
      </v-col>
      <v-col class="text-sm text-primary" v-if="schedulesFilter?.length" cols="12">
        Escalas:
        <span class="font-bold"> {{ schedulesFilter?.map((s) => s.text).join(', ') }}</span>
      </v-col>
    </v-row>
    <template #footer>
      <v-row dense class="pt-5">
        <v-col cols="6">
          <ghost-button @click="handleToggleModal" width="100%" text="Cancelar" />
        </v-col>
        <v-col cols="6">
          <filled-button
            :loading="isLoading"
            @click="handleExport"
            text="Exportar"
            height="52px"
            width="100%"
          />
        </v-col>
      </v-row>
    </template>
  </modal-vue>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import { ref } from 'vue'
import Network from '@/Network'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import { mdiCalendar } from '@mdi/js'
import { DatePicker } from 'v-calendar'
import * as pdfMake from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'
import { TDocumentDefinitions } from 'pdfmake/interfaces'
import { getDocDefinition, getWeeksBetweenDates } from './helpers'
import {
  DashboardType
  //  ListFiltersRequest
} from '@/Network/Types/Requests/StationRequests'
import { ListStationsResponse } from '@/Network/Types/Responses/StationResponses'
import { useStationStore } from '@/pinia-store/useStationStore'
import { computed } from 'vue'
import { useHealthUnitStore } from '@/pinia-store/useHealthUnitStore'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { watch } from 'vue'
import { formatDateToString } from '@/utils/date'
import Card from './components/card.vue'
import {
  getDay,
  addDays,
  // startOfWeek,
  endOfWeek
} from 'date-fns'
/* ******** Modal Props and Actions Default *********** */
const modalName = EModals.EXPORT_DASHBOARD_STATIONS
const { modals } = storeToRefs(useModalStore())
const modalStore = useModalStore()
const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
}
/* **************************************************** */
const toast = useToast()
const { notifyError } = useErrorToast()
const isLoading = ref<boolean>(false)

const { listStationsQuery } = storeToRefs(useStationStore())
const healthUnitStore = useHealthUnitStore()
const scheduleStore = useScheduleStore()
const { healthUnitsMap } = storeToRefs(healthUnitStore)
const { schedulesMap } = storeToRefs(scheduleStore)
const startDateError = ref<string>('')
const startDate = ref<Date>(new Date())

watch(
  () => startDate.value,
  () => {
    if (!startDate.value) {
      startDateError.value = 'Data inicial é obrigatória'
      return
    }
    startDateError.value = ''
  }
)
const endDateError = ref<string>('')
const endDate = ref<Date>(new Date())
watch(
  () => endDate.value,
  () => {
    if (!endDate.value) {
      endDateError.value = 'Data final é obrigatória'
      return
    }
    endDateError.value = ''
  }
)

const openedStation = ref<boolean>(true)
const stationFixo = ref<boolean>(true)
const stationCobertura = ref<boolean>(true)
const stationExtra = ref<boolean>(true)
const doctorPending = ref<boolean>(true)
const confirmed = ref<boolean>(true)
const notConfirmed = ref<boolean>(true)
const hideLabels = ref<boolean>(false)

const schedulesFilter = computed(() => {
  if (!listStationsQuery) return
  return listStationsQuery.value.schedules?.map((u) => ({
    id: u,
    text: schedulesMap.value.get(+u)
  }))
})

const unitsFilter = computed(() => {
  if (!listStationsQuery) return
  return listStationsQuery.value.healthUnits?.map((u) => ({
    id: u,
    text: healthUnitsMap.value.get(+u)
  }))
})

const getStations = async (): Promise<
  { weekStartDate: string; responseData: ListStationsResponse }[]
> => {
  let effectiveStartDate = new Date(startDate.value)
  let effectiveEndDate = new Date(endDate.value)

  if (getDay(effectiveStartDate) === 0) {
    effectiveStartDate = addDays(effectiveStartDate, 1)

    if (effectiveStartDate > effectiveEndDate) {
      effectiveEndDate = endOfWeek(effectiveStartDate, { weekStartsOn: 1 })
    }
  }

  const weeks = getWeeksBetweenDates(effectiveStartDate, effectiveEndDate)

  if (weeks.length === 0) {
    toast.warning('Nenhum período semanal válido encontrado para as datas selecionadas.')
    return []
  }

  const requests = weeks.map((week) => ({
    ...listStationsQuery.value,
    startDate: week.startDate,
    endDate: week.endDate,
    type: DashboardType.WEEK,
    doctorPending: getDoctorPending(),
    openedStation: getOpenedStation(),
    stationType: getStationType()
  }))

  const responses = await Promise.all(
    weeks.map(async (week, i) => {
      const data = await Network.station.list(requests[i])
      return {
        weekStartDate: week.weekStartDate,
        responseData: data
      }
    })
  )

  return responses.filter((item) => item.responseData && item.responseData.data)
}

const getStationType = (): string[] | undefined => {
  const stationsTypes: string[] = []
  if (stationFixo.value) stationsTypes.push('FIXO')
  if (stationCobertura.value) stationsTypes.push('COBERTURA')
  if (stationExtra.value) stationsTypes.push('EXTRA')

  return stationsTypes.length ? stationsTypes : undefined
}

const getDoctorPending = (): string | undefined => {
  // No backend, doctorPending filtra por confirmação do plantão:
  // true → só não confirmados; false → só confirmados; omitido → todos.
  // O checkbox "Médico Pendente" é apenas legenda visual e não entra na request.
  if (confirmed.value === notConfirmed.value) return undefined
  return String(notConfirmed.value)
}

const removePendingDoctorCards = (
  weeks: { weekStartDate: string; responseData: ListStationsResponse }[]
) => {
  // O backend não tem filtro por convite pendente (doctorPending na response),
  // então com o checkbox "Médico Pendente" desmarcado os cards são removidos aqui.
  if (doctorPending.value) return weeks
  weeks.forEach(({ responseData }) =>
    responseData.data?.forEach((company) =>
      company.healthUnities?.forEach((unit) =>
        unit.schedules?.forEach((schedule) =>
          schedule.shifts?.forEach((shift) =>
            shift.hours?.forEach((hour) =>
              hour.positions?.forEach((position) => {
                position.stations = position.stations?.map(
                  (day) => day?.filter((card) => !card?.doctorPending) ?? day
                )
              })
            )
          )
        )
      )
    )
  )
  return weeks
}

const getOpenedStation = (): string | undefined => {
  const hasOtherStationType = stationFixo.value || stationCobertura.value || stationExtra.value
  if (openedStation.value && hasOtherStationType) return undefined
  return String(openedStation.value)
}

const handleExport = async () => {
  try {
    isLoading.value = true

    // Busca os dados (já com a correção dos filtros de Unidades e Escalas que fizemos antes)
    const data = removePendingDoctorCards(await getStations())

    // Validação se há dados retornados
    if (!data.length || data.every((item) => !item.responseData?.data?.length)) {
      toast.warning('Nenhum dado encontrado para o período e filtros selecionados.')
      return
    }

    // Gera a definição do PDF passando os dados E o booleano para ocultar legendas
    const docDefinition: TDocumentDefinitions = getDocDefinition(data, hideLabels.value)

    // Cria o binário do PDF
    const pdf = pdfMake.createPdf(
      docDefinition,
      undefined,
      undefined,
      (pdfFonts as Record<string, unknown>).vfs as Record<string, string>
    )

    // Gera o Blob e força o download
    pdf.getBlob((blob) => {
      const file = new Blob([blob], { type: 'application/octet-stream' })
      const a = document.createElement('a')
      a.href = URL.createObjectURL(file)
      a.target = '_blank'
      a.download = `Plantoes de ${formatDateToString(startDate.value)} ate ${formatDateToString(
        endDate.value
      )}.pdf`
      a.click()
    })

    toast.success('PDF exportado com sucesso')
    handleToggleModal()
  } catch (error) {
    console.error(error)
    // Antes: "Erro ao exportar PDF" estático — o load dos plantões (service
    // normalizado) pode falhar com mensagem específica.
    notifyError(error, 'Não foi possível exportar o PDF')
  } finally {
    isLoading.value = false
  }
}
</script>
<style scoped>
.card {
  @apply flex justify-center items-center w-full  h-[105px] font-bold text-xs rounded;
}
</style>
